import React from "react";
import "./Articles.css";

const articles = [
    {
        id: 1,
        title: "How I Set Up OpenClaw on my Old MacBook Air to automate my life",
        description: "With the boom of OpenClaw (ClawdBot), Mac Minis sells have skyrocketed. But what many people don’t realize is that you can run it on a in 7 year old device.",
        image: "/img/article-cover1.jpg",
        link: "https://x.com/cesaralvarezll/status/2023721377975423281",
    },
    {
        id: 2,
        title: "How I Went From 0 Mobile Experience to 3 Apps in the App Store in 30 Days",
        description: "I started with zero mobile experience and, in just 30 days, I built and launched three apps that are now generating revenue.",
        image: "/img/article-cover2.jpg",
        link: "https://x.com/cesaralvarezll/status/2028843750424731765",
    },
    {
        id: 3,
        title: "I studied more than 200 app onboardings flows. Here's what I learned",
        description: "For the past 3 months, I have been studying the onboardings of the top mobile apps. I learned a lot about how to make them and how to convert better.",
        image: "/img/article-cover3.jpg",
        link: "https://x.com/cesaralvarezll/status/2058845832816816566",
    },
    {
        id: 4,
        title: "How to Create AI UGC Ads That Actually Sell Your App",
        description: "Building apps has never been more accessible. Anyone can ship something now. The hard part isn't building anymore. It's getting anyone to care about your app.",
        image: "/img/article-cover4.jpg",
        link: "https://x.com/cesaralvarezll/status/2067570829399818626",
    },
];

function Articles() {
    return (
        <section className="articles section" id="articles">
            <h2 className="section__title">Articles</h2>
            <span className="section__subtitle">What I've been writing</span>

            <div className="articles__container container grid">
                {articles.map((article) => (
                    <a
                        key={article.id}
                        href={article.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="articles__card"
                    >
                        <div className="articles__img-wrapper">
                            <img
                                src={article.image}
                                alt={article.title}
                                className="articles__img"
                            />
                        </div>
                        <div className="articles__info">
                            <h3 className="articles__name">{article.title}</h3>
                            <p className="articles__description">{article.description}</p>
                            <span className="articles__cta">
                                Read on
                                <svg
                                    className="articles__cta-icon"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="15"
                                    height="15"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                    style={{ marginLeft: "0.15rem" }}
                                >
                                    <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z" />
                                </svg>
                            </span>
                        </div>
                    </a>
                ))}
            </div>
        </section>
    );
}

export default Articles;
